export class EmployerLiability {
    id: string = null;
    number_of_employees: number = null;
    ern_number: string = '';   
}
